import { Card, Col, Row, Skeleton, Statistic } from 'antd';

import type { CollectionStats } from '../api/backend';

const compactNumber = (value: number): string =>
    new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 2 }).format(value);

interface StatsBarProps {
    stats: CollectionStats | null;
    loading: boolean;
}

interface StatCell {
    title: string;
    value: string;
    suffix?: string;
}

const StatsBar = ({ stats, loading }: StatsBarProps) => {
    if (!loading && !stats?.total) return null; // stats endpoint failed — page still works without it

    const total = stats?.total;
    const symbol = total?.floor_price_symbol || 'POL';
    const dayInterval = stats?.intervals?.find((interval) => interval.interval === 'one_day') || stats?.intervals?.[0];

    const cells: StatCell[] = [
        {
            title: 'Floor Price',
            value: total?.floor_price != null ? String(parseFloat(total.floor_price.toPrecision(4))) : '—',
            suffix: symbol,
        },
        {
            title: 'Market Cap',
            value: total?.market_cap != null ? compactNumber(total.market_cap) : '—',
            suffix: symbol,
        },
        {
            title: '24h Volume',
            value: dayInterval?.volume != null ? compactNumber(dayInterval.volume) : '—',
            suffix: symbol,
        },
        {
            title: 'Owners',
            value: total?.num_owners != null ? total.num_owners.toLocaleString('en-US') : '—',
        },
    ];

    return (
        <Row gutter={[12, 12]}>
            {cells.map((cell) => (
                <Col key={cell.title} xs={12} lg={6}>
                    <Card size='small'>
                        {loading ? (
                            <Skeleton active paragraph={false} title={{ width: '60%' }} />
                        ) : (
                            <Statistic
                                title={cell.title}
                                value={cell.value}
                                suffix={cell.suffix}
                                valueStyle={{ fontSize: 20, fontWeight: 700 }}
                            />
                        )}
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default StatsBar;
